import React from 'react'
import { Row, Col } from 'ui/elements/Grid'
import Icon from 'ui/elements/Icon'
import { useTranslation } from 'gatsby-plugin-react-i18next'

import * as S from './styles'
import Link, { useNavigation } from 'widgets/Link'

const ProgramsIntro: React.FC<{
  intro: string | undefined
}> = ({ intro }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation('homepage')
  const navigation = useNavigation()

  return (
    <S.ProgramsIntro>
      <Row $justify="around">
        <Col $xs={12}>
          <S.Intro>{intro}</S.Intro>
        </Col>
        <Col $xs={12} $lg={6}>
          <S.NavBox color="secondaryAlpha" as={Link} to="/open-programs/">
            <Icon size={70} name="open-programs" />
            <header>
              <span className="h1">{t('intro.openPrograms.title')}</span>
              <span className="h5">{t('intro.openPrograms.subtitle')}</span>
            </header>
          </S.NavBox>
        </Col>
        <Col $xs={12} $lg={6}>
          <S.NavBox
            color="otherAlpha"
            as={Link}
            to={{
              type: 'external',
              href:
                language === 'de'
                  ? 'https://www.whu.edu/de/programme/executive-education/customized-programs/'
                  : 'https://www.whu.edu/en/programs/executive-education/customized-programs/',
            }}
          >
            <Icon size={70} name="customized-programs" />
            <header>
              <span className="h1">{t('intro.customizedPrograms.title')}</span>
              <span className="h5">
                {t('intro.customizedPrograms.subtitle')}
              </span>
            </header>
          </S.NavBox>
        </Col>
      </Row>
    </S.ProgramsIntro>
  )
}

export default ProgramsIntro
